import * as React from "react";
import moment from 'moment'
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";
import { RepeatableSection } from "../components/RepeatableSection";
import { CurrencyModel } from "@/app/models/newDelegation/currencyModel";
import { MinimumWageCountryAdditionExpandableItemModel } from "@/app/models/configuration/minimumWage/minimumWageCountryAdditionExpandableItemModel";

type Props = {
    allowedCurrencies?: string[]
    title?: string
    state: {
        configuration: { currencies: CurrencyModel[] }
        countryAdditionsExpandableItems: MinimumWageCountryAdditionExpandableItemModel[]
    }
    setState: React.Dispatch<React.SetStateAction<{ countryAdditionsExpandableItems: MinimumWageCountryAdditionExpandableItemModel[] }>>
}

export const MinimumWageCountryAdditionExpandableItemSection = ({ allowedCurrencies, title, state, setState }: Props) => {
    const { t } = useLocalize()

    return (
        <RepeatableSection<MinimumWageCountryAdditionExpandableItemModel>
            title={title || t('configuration.minimumWages.minimalCountryAdditionTitle')}
            newRow={() => ({
                additionCurrency: { id: 1, code: "PLN", name: "złoty" },
                additionValue: 0,
                configurationValueId: 0,
                dateFrom: moment(),
                isNew: true,
            })}
            columns={[
                {
                    order: 1,
                    label: t('configuration-minimumWage.from-date'),
                    type: "date",
                    get: (r) => r.dateFrom,
                    set: (r, v) => ({ ...r, dateFrom: moment(v) }),
                },
                {
                    order: 3,
                    label: t('common.amount'),
                    type: "price",
                    get: (r) => r.additionValue,
                    set: (r, v: number) => ({ ...r, additionValue: Number(v) }),
                },
                {
                    order: 5,
                    label: t("configuration.countries.currency"),
                    type: "select", //"currency",
                    options: state.configuration.currencies.filter(c => allowedCurrencies ? allowedCurrencies.includes(c.code) : true).map((c) => ({ label: `${c.code} - ${c.name}`, value: c.code })).sort((a, b) => a.label.localeCompare(b.label)),
                    get: (r) => r.additionCurrency.code,
                    set: (r, v) => {
                        const selected = state.configuration.currencies.find(c => c.code === v)
                        return ({ ...r, additionCurrency: selected })
                    }
                },
            ]}
            canAddRow={true}
            rows={state.countryAdditionsExpandableItems}
            setRows={(next) => {
                setState(prev => {
                    const current = prev.countryAdditionsExpandableItems;
                    const nextRows = typeof next === "function" ? (next as (p: typeof current) => typeof current)(current) : next;
                    return { ...prev, countryAdditionsExpandableItems: nextRows };
                });
            }}
            sortRows={(a, b) => {
                const da = moment(a.dateFrom)
                const db = moment(b.dateFrom)
                const ta = da.valueOf()
                const tb = db.valueOf()
                if(ta===tb) return 0
                return ta > tb ? -1 : 1
            }}
        />
    )
}
